import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { fetchPrompts, fetchPromptVersions } from "./api"

export function usePrompts(bookId?: string) {
  const getContext = useApiContext(bookId)

  return useQuery({
    queryKey: ["prompts", bookId],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchPrompts(context)
    },
    enabled: !!bookId,
  })
}

interface UsePromptVersionsParams {
  bookId?: string
  promptId?: string
  key?: string
}

export function usePromptVersions({ bookId, promptId, key }: UsePromptVersionsParams) {
  const getContext = useApiContext(bookId)

  return useQuery({
    queryKey: ["prompt", promptId, "versions", key],
    queryFn: async () => {
      if (!promptId) throw new Error("Prompt id is required")

      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchPromptVersions(context, promptId, key)
    },
    enabled: !!bookId && !!promptId,
  })
}
